import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Signature électronique — paraphe sur une ligne duotone */
export const SignatureIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Soulignement menthe */}
      <path d="M3 20h18" stroke="var(--equiply-icon-bg)" strokeWidth="2.5" strokeLinecap="round" />
      {/* Paraphe stylisé */}
      <path
        d="M4 16c2-1 4-7 6-7s1 5 3 5 3-4 5-3"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
      />
      {/* Étoile/sparkle d'authenticité */}
      <path
        d="M18.5 5l.5 1.3L20.3 7l-1.3.7L18.5 9l-.5-1.3L16.7 7l1.3-.7L18.5 5z"
        fill="var(--equiply-icon-fg)"
      />
    </svg>
  ),
);
SignatureIcon.displayName = "SignatureIcon";
